import "./allCategories";
import "./search";
import "./wishlist";
import "./HandlerWishlist";
import "./fixedMenu";
